import { render, staticRenderFns } from "./MultiselectGroupedList.vue?vue&type=template&id=dc671350&scoped=true"
import script from "./MultiselectGroupedList.vue?vue&type=script&lang=js"
export * from "./MultiselectGroupedList.vue?vue&type=script&lang=js"
import style0 from "./MultiselectGroupedList.vue?vue&type=style&index=0&id=dc671350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc671350",
  null
  
)

export default component.exports